import type { ConfirmLeaveCopy } from './confirm-leave-modal';

/**
 * The words of the save-or-discard question an editor asks before an unsaved
 * edit would be lost: go back to it, discard it, or save it and go on.
 */
export const SAVE_OR_DISCARD_COPY = {
  title: 'Save or discard your changes?',
  cancelLabel: 'Go back',
  saveLabel: 'Save & continue',
} as const satisfies ConfirmLeaveCopy;

/** The question's body while the edit can be saved. */
export const SAVE_OR_DISCARD_PROMPT = 'Save your changes or discard them to continue.';

/** The question's body while the edit cannot be saved, so discarding is the only way on. */
export const SAVE_DISABLED_PROMPT = 'Discard your changes, or correct the errors to save.';

/** The line above the question's body while the edit cannot be saved as it stands. */
export const INVALID_STATUS = 'Required fields must be filled out.';
